export default function (mortgage, config) {
	const map={
		'app1-name': mortgage.applicant1.fullName
	}
	if (mortgage.twoApplicants){
		map['app2-name'] = mortgage.applicant2.fullName
	}
	if (mortgage.property.address){
		let addressParts = mortgage.property.address.split(',').map(e=>e.trim()).filter(e=>e!=="")
		while (addressParts.length > 3) {
			// Merge the last two parts to reduce the number of lines
			addressParts[addressParts.length - 2] += `, ${addressParts.pop()}`;
		}
		map['address-1'] = addressParts[0]
		if (addressParts.length > 1){
			map['address-2'] = addressParts[1]
		}
		if (addressParts.length > 2){
			map['address-3'] = addressParts[2]
		}
	}
	if (mortgage.activeSubmission?.mortgageAccountNo){
		map['account-number'] = mortgage.activeSubmission?.mortgageAccountNo
	}



	return {sections:[{map}]}

}